import { AwsUi } from '../../../core/runtime/src';
import { Alert } from '../../alert/src';
export { FormSection } from './form-section';
export var Form = AwsUi.__addComponent('awsui-form', {
    releaseStatus: 'stable',
    regions: {
        // Rendered inside the form.
        content: {
            isDefault: true
        },
        // Title of the form (mandatory).
        header: {},
        // General description of the form (optional).
        description: {},
        // Additional form level validation message (optional).
        errorText: {},
        // Form action buttons are supposed to be placed here.
        actions: {}
    },
    render: function (m, h) {
        var _this = this;
        var errorText = function () {
            if (!_this.errorText) {
                return;
            }
            return (AwsUi.__createElement("div", { className: "awsui-form-error" },
                AwsUi.__createElement(Alert, { type: "error", content: h.region('errorText') })));
        };
        return (AwsUi.__createElement("div", { className: "awsui-form" },
            AwsUi.__createElement("div", { className: "awsui-form-header" },
                h.region('header', 'div', { className: 'awsui-form-title' }),
                h.region('description', 'div', { className: 'awsui-form-description' })),
            h.region('content', 'div', { className: 'awsui-form-content' }),
            AwsUi.__createElement("div", { "aria-live": "assertive" }, errorText()),
            h.region('actions', 'div', { className: 'awsui-form-actions' })));
    }
});
//# sourceMappingURL=index.js.map